export default "__VITE_ASSET__C0i0vGN1__"